import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { BookingDAO } from '../../../../../core/services/dao/bookingDAO';
import { RoleDAO } from '../../../../../core/services/dao/roleDAO';
import { AuthService } from '../../../../../core/services/auth.service';
import { merge } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { ApiHelper } from '../../../../../core/services/apiHelper';
import { environment } from '../../../../../environments/environment';

@Injectable()
export class EditBookingResolve implements Resolve<any> {
  constructor(
    private bookingDAO: BookingDAO,
    private roleDAO: RoleDAO,
    private authService: AuthService,
    private apiHelper: ApiHelper,
  ) {
    this.apiHelper.setEnvironment(environment.envName);
  }

  resolve(route: ActivatedRouteSnapshot) {
    const bookingResolve = this.bookingDAO.loadById(route.params.id);
    const sessionResolve = this.authService.checkSession();
    const mergeResolve = merge(sessionResolve, bookingResolve);
    return mergeResolve.pipe(
      take(2),
      map((data) => data),
    );
  }
}
